import React, { createContext, useState, useEffect } from "react";
import { ToastProvider } from "../updatedComponents/Toaster/Toaster";
import { NotificationProvider } from "./NotificationContext";

// Enum definition
export const THEME = Object.freeze({
  SYSTEM: "SYSTEM",
  LIGHT: "LIGHT",
  DARK: "DARK",
});

const AuthContext = createContext({});

const AuthProvider = (props) => {
  const [switchDisplay, setSwitchDisplay] = useState(false);
  // const [marketingRefresh, setMarketingRefresh] = useState(false);
  const [designation, setDesignation] = useState("");
  const [designations, setDesignations] = useState([]);
  const [managerId, setManagerId] = useState("");
  const [managerName, setManagerName] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [updateDelete, setUpdateDelete] = useState(0);
  const [totalUnreadChat, setTotalUnreadChat] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // const [orderData, setOrderData] = useState([]);
  const [Warehouse, setWarehouse] = useState([]);
  // const [mainWarehouse, setMainWarehouse] = useState("");
  const [saleWhatsapp, setSaleWhatsapp] = useState(true);
  // const [selectedOption, setSelectedOption] = useState("");
  const [openSearchModal, setOpenSearchModal] = useState(false);

  // const [orderdDaysTab, setOrderDaysTab] = useState("today");
  // const [orderStartDate, setOrderStartDate] = useState("");
  // const [orderEndDate, setOrderEndDate] = useState("");

  // const [receiptStartDate, setReceiptStartDate] = useState("");
  // const [receiptEndDate, setReceiptEndDate] = useState("");
  // const [receiptDaysTab, setReceiptDaysTab] = useState("today");

  const [paymentGatewayAccess, setPaymentGatewayAccess] = useState(false);
  const [settingsData, setSettingsData] = useState(() => {
    try {
      const saved = localStorage.getItem("settingsData");
      return saved
        ? JSON.parse(saved)
        : {
            companyLogo: "",
            companyName: "",
            paymentGatewayAccess: false,
            projectName: "",
            websiteLink: "",
          };
    } catch {
      return {
        companyLogo: "",
        companyName: "",
        paymentGatewayAccess: false,
        projectName: "",
        websiteLink: "",
      };
    }
  });

  // ADD this useEffect anywhere in AuthProvider
  useEffect(() => {
    if (settingsData.projectName) {
      localStorage.setItem("settingsData", JSON.stringify(settingsData));
    }
  }, [settingsData]);

  const [selectedTheme, setSelectedTheme] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("theme") || THEME.SYSTEM;
    }
    return THEME.SYSTEM;
  });

  const [mode, setMode] = useState(() => {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("theme") || THEME.SYSTEM;
      if (savedTheme === THEME.SYSTEM) {
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
      } else {
        return savedTheme === THEME.DARK;
      }
    }
    return false; // default light
  });

  // const [voucherTab, setVoucherTab] = useState("Order");

  useEffect(() => {
    localStorage.setItem("theme", selectedTheme);
  }, [selectedTheme]);

  useEffect(() => {
    if (selectedTheme !== THEME.SYSTEM) {
      localStorage.setItem("mode", mode ? "dark" : "light");
    }
  }, [mode, selectedTheme]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleSystemThemeChange = (e) => {
      if (selectedTheme === THEME.SYSTEM) {
        setMode(e.matches);
      }
    };

    if (selectedTheme === THEME.SYSTEM) {
      setMode(mediaQuery.matches);
      mediaQuery.addEventListener("change", handleSystemThemeChange);
    }

    return () =>
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
  }, [selectedTheme]);

  const toggleTheme = (theme) => {
    setSelectedTheme(theme);
    if (theme === THEME.SYSTEM) {
      const systemColorScheme = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches
        ? THEME.DARK
        : THEME.LIGHT;
      setMode(systemColorScheme === THEME.DARK);
    } else {
      setMode(theme === THEME.DARK);
    }
  };

  // console.log("ware house ", Warehouse)

  // const handleVoucherChange = (voucherOptions, v) => {
  //   const selectedFilter = voucherOptions.find((item) => item === v);
  //   setVoucherTab(selectedFilter || "Order");
  // };

  const startTimer = () => {
    const now = Date.now();
    localStorage.setItem("loginTime", now);
  };

  const clearTimer = () => {
    localStorage.removeItem("loginTime");
  };

  const handleSignOut = () => {
    sessionStorage.clear();
    localStorage.removeItem("settingsData");
    window.location.href = "/";
    clearTimer();
  };
  const authContextValue = {
    switchDisplay,
    setSwitchDisplay,
    // marketingRefresh,
    // setMarketingRefresh,
    designation,
    setDesignation,
    designations,
    setDesignations,
    managerId,
    setManagerId,
    managerName,
    setManagerName,
    loggedIn,
    setLoggedIn,
    updateDelete,
    setUpdateDelete,
    totalUnreadChat,
    setTotalUnreadChat,
    selectedTheme,
    toggleTheme,
    mode,
    setMode,
    isLoading,
    setIsLoading,
    // voucherTab,
    // setVoucherTab,
    // handleVoucherChange,
    // orderData,
    // setOrderData,
    Warehouse,
    setWarehouse,
    // selectedOption,
    // setSelectedOption,
    // mainWarehouse,
    // setMainWarehouse,
    saleWhatsapp,
    setSaleWhatsapp,
    openSearchModal,
    setOpenSearchModal,
    startTimer,
    clearTimer,
    handleSignOut,
    // orderdDaysTab,
    // setOrderDaysTab,
    // orderStartDate,
    // setOrderStartDate,
    // orderEndDate,
    // setOrderEndDate,
    // receiptDaysTab,
    // setReceiptDaysTab,
    // receiptStartDate,
    // setReceiptStartDate,
    // receiptEndDate,
    // setReceiptEndDate,
    paymentGatewayAccess,
    setPaymentGatewayAccess,
    settingsData,
    setSettingsData,
  };

  return (
    <NotificationProvider>
      <ToastProvider mode={mode}>
        <AuthContext.Provider value={authContextValue} {...props} />
      </ToastProvider>
    </NotificationProvider>
  );
};

const useAuth = () => React.useContext(AuthContext);
export { AuthProvider, useAuth };
